import { render, staticRenderFns } from "./CVDIPigeanTable.vue?vue&type=template&id=a41a20b8&scoped=true&"
import script from "./CVDIPigeanTable.vue?vue&type=script&lang=js&"
export * from "./CVDIPigeanTable.vue?vue&type=script&lang=js&"
import style0 from "./CVDIPigeanTable.vue?vue&type=style&index=0&id=a41a20b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41a20b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a41a20b8')) {
      api.createRecord('a41a20b8', component.options)
    } else {
      api.reload('a41a20b8', component.options)
    }
    module.hot.accept("./CVDIPigeanTable.vue?vue&type=template&id=a41a20b8&scoped=true&", function () {
      api.rerender('a41a20b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CVDI_Pigean/CVDIPigeanTable.vue"
export default component.exports